/**
 * Survol d'une carte produit : le média secondaire est révélé en superposition de la
 * première diapositive du carrousel (voir snippets/product-card.liquid et le bloc
 * « Média secondaire au survol » de theme.css). Ce même média a aussi sa diapositive
 * dans le carrousel — au survol, la flèche suivante réaffichait donc l'image déjà
 * visible avant de passer à la suivante.
 *
 * On intercepte le clic en phase de capture, donc avant le listener de
 * <carousel-prev-button> / <carousel-next-button> (theme.js), et on saute la
 * diapositive marquée `data-hover-duplicate` pour aller directement à la suivante.
 * Rien n'est modifié quand le survol n'est pas actif, quand la flèche ne tombe pas
 * pile sur cette diapositive, ou quand il n'y a rien derrière elle à montrer.
 */
(() => {
  const finePointer = window.matchMedia('(pointer: fine)');

  document.addEventListener(
    'click',
    (event) => {
      // Même condition que le CSS qui révèle le média secondaire.
      if (!finePointer.matches) return;

      const button = event.target.closest?.(
        'carousel-prev-button, carousel-next-button'
      );
      if (!button) return;

      const card = button.closest('product-card');
      if (!card || !card.matches(':hover')) return;

      const carousel = document.getElementById(button.getAttribute('aria-controls'));
      if (!carousel || typeof carousel.select !== 'function') return;

      const cells = carousel.cells;
      const duplicate = cells.findIndex((cell) =>
        cell.hasAttribute('data-hover-duplicate')
      );
      if (duplicate < 0) return;

      const step = button.matches('carousel-next-button') ? 1 : -1;
      // La flèche allait-elle tomber pile sur la diapositive déjà vue au survol ?
      if (carousel.selectedIndex + step !== duplicate) return;

      // Reste-t-il quelque chose derrière ? Sinon on laisse le comportement natif.
      const target = duplicate + step;
      if (!(target in cells)) return;

      event.stopPropagation();
      carousel.select(target);
    },
    true
  );
})();
